<template>
  <transition name="mask-fade">
    <div class="ul-resource-preview__wrapper">
      <div class="ul-resource-preview">
        <div class="ul-resource__header">
          <h4>{{resource.fileName}}</h4>
          <div class="ul-resource__header__right">
            <i class="iconfont icon-guanbi1" @click="hide"></i>
          </div>
        </div>
        <div class="ul-resource__body">
          <div class="resource-image" v-if="fileType == 'image'">
            <img :src="filePath">
          </div>
          <div class="resource-document" v-if="fileType == 'document'">
            <div class="wrapper">
              <iframe :src="filePath"></iframe>
            </div>
          </div>
          <div class="resource-video" v-if="fileType == 'video'">
            <div class="video-wrapper">
              <video :id="'video-media'" width="100%" height="100%" playsinline webkit-playsinline class="custom-video">
                <source type="video/mp4" :src="filePath" />
              </video>
            </div>
          </div>
          <div class="resource-audio" v-if="fileType == 'audio'">
            <div class="audio-wrapper">
              <AudioComponent :src="filePath"></AudioComponent>
            </div>
          </div>
          <div class="resource-other" v-if="fileType == 'other' || fileType == 'zip' || fileType == 'flash' || fileType == 'srt'">
            <div class="other-wrapper">
              <i class="iconfont" :class="[fileIcon(resource.filePath)]"></i>
              <div>该文件不支持在线预览</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { fileType, getFullPath, fileIcon} from '@/utils/file.js'
import { DOCS_HOST } from '@/config'
import 'mediaelement'
import 'mediaelement/build/mediaelementplayer.min.css'
import AudioComponent from './audio.vue'
export default {
  name: 'ResourcePreviewComponent',
  props: {
    resource:{
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    fileType () {
      return fileType(this.resource.filePath)
    },
    filePath () {
      let path = this.resource.filePath
      if (this.fileType == 'document') {
        var src = DOCS_HOST + "?time=1";
        var location = getFullPath(path)
        if (location.indexOf("https://") != -1) {
          src += "&ssl=1";
        }
        location = encodeURIComponent(location);
        src += "&furl=" + location;
        path = src
      } else if (this.fileType == 'video') {
        path = path.substring(0,path.lastIndexOf('.')) + '.mp4'
        if (path.indexOf('homework/') > -1) {
          path = path.substring(0,path.lastIndexOf('.')) + '_convert.mp4'
        }
        path = getFullPath(path)
      } else {
        path = getFullPath(path)
      }
      return path
    }
  },
  filters: {
    fullPath (input) {
      return getFullPath(input)
    }
  },
  data () {
    return {
    }
  },
  mounted () {

     if(this.fileType == 'video') {
      this.player = new MediaElementPlayer('video-media', {
        success: (mediaElement) => {
          this.media = mediaElement
          // this.map.set(this.media, {
          //   src: this.sourceUrl,
          //   currentTime: mediaElement.getCurrentTime()
          // })
        },
        error: (event) => {
          console.log(event.detail)
          setTimeout(()=> {
             event.detail.target.parentElement.nextElementSibling.getElementsByClassName('mejs__cannotplay')[0].getElementsByTagName('a')[0].setAttribute('href','javascript:;')
          },300)
         
        }
      })
      this.$once('hook:beforeDestroy', () => {
        const { player } = this
        if (!player.paused) {
          player.pause()
        }
      })
    }
  },
  methods: {
    fileIcon,
    hide () {
      this.$emit('hide')
    }
  },
  components: {
    AudioComponent
  }
}
</script>

<style lang="scss" scoped>
.ul-resource-preview__wrapper{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0,0,0,0.8);
  z-index: 3000;
  .ul-resource-preview {
    height: 100%;
  }
}
.ul-resource__header{
  position: fixed;
  z-index: 3001;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  padding: 10px 20px;
  background-color: rgba(0,0,0,0.7);
  box-sizing: border-box;
  color: #fff;
  h4{
    margin: 0;
    float: left;
    font-size: 16px;
    line-height: 30px;
  }
}
.ul-resource__header__right{
  float: right;
  i{
    font-size: 14px;
    cursor: pointer;
  }
}

.ul-page__header-right{
  float: right;
}
.ul-resource__body{
  padding: 70px 0 20px 0px;
  text-align: center;
  height: 100%;
}
.resource-image{
  img{
    max-width: 800px;
    max-height: 500px;
  }
}
.resource-document{
  iframe{
    width: 940px;
    height: calc(100vh - 130px);
    background: #fff;
  }
}
::v-deep.resource-video{
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .video-wrapper{
    height: 450px;
    max-height: 450px;
    width: 800px;
    margin: 0 auto;
    .custom-video {
      height: 450px;
      max-height: 450px;
    }
    .mejs__container-fullscreen video{
      max-height: 100%;
    }
    .mejs__container {
      height: 450px;
      max-height: 450px;
    }
  }
  
}

.audio-wrapper{
  width: 280px;
  margin: 70px auto;
}

.resource-other {
  position: absolute;
  left: 50%;
  margin-left: -425px;
  margin-top: -240px;
  background-color: #fff;
  display: flex;
  width: 850px;
  height: 480px;
  top: 50%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  i {
    font-size: 80px;
    margin-bottom: 32px;
  }
  div {
    font-size: 16px;
  }
}

.mask-fade-enter-active {
  animation: mask-fade-in .3s;
}

.mask-fade-leave-active {
  animation: mask-fade-out .3s;
}

@keyframes mask-fade-in {
  0% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes mask-fade-out {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
}

</style>